import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './submission.reducer';

export const SubmissionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const submissionEntity = useAppSelector(state => state.submission.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="submissionDetailsHeading">
          <Translate contentKey="tycheApp.submission.detail.title">Submission</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{submissionEntity.id}</dd>
          <dt>
            <span id="submissionDate">
              <Translate contentKey="tycheApp.submission.submissionDate">Submission Date</Translate>
            </span>
          </dt>
          <dd>
            {submissionEntity.submissionDate ? (
              <TextFormat value={submissionEntity.submissionDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="requestBody">
              <Translate contentKey="tycheApp.submission.requestBody">Request Body</Translate>
            </span>
          </dt>
          <dd>{submissionEntity.requestBody}</dd>
          <dt>
            <span id="responseBody">
              <Translate contentKey="tycheApp.submission.responseBody">Response Body</Translate>
            </span>
          </dt>
          <dd>{submissionEntity.responseBody}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tycheApp.submission.status">Status</Translate>
            </span>
          </dt>
          <dd>{submissionEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/submission" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/submission/${submissionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubmissionDetail;
